// extracted by mini-css-extract-plugin
module.exports = {"root":"ChoiceImage_root__2NfqG"};